import type { DriveAssessmentConfigs } from '../types'
import { testGuidelines, testSections } from '../utils/testInstructions'

export default function AutomaticTestInstructions({ configs, showGuidelines = true }: {
  configs?: DriveAssessmentConfigs | null
  showGuidelines?: boolean
}) {
  const sections = testSections(configs)
  const rules = testGuidelines(!sections.length || !sections.every(section => section.type === 'aiml_assignment'))
  return (
    <section className="space-y-3">
      <h3 className="font-semibold text-gray-900">Test Instructions</h3>
      {sections.length ? (
        <>
          <ul className="space-y-2 text-sm text-gray-700">
            {sections.map(section => (
              <li key={section.type}>
                <span className="font-medium">{section.name}:</span> {section.questions} questions · {section.minutes} minutes
              </li>
            ))}
          </ul>
          <p className="text-sm font-semibold text-gray-900">
            Total: {sections.reduce((n, section) => n + section.questions, 0)} questions · {sections.reduce((n, section) => n + section.minutes, 0)} minutes
          </p>
        </>
      ) : <p className="text-sm text-gray-600">Section details will appear when the assessment configuration is available.</p>}
      {showGuidelines ? <ul className="list-disc space-y-2 pl-5 text-sm text-gray-600">{rules.map(rule => <li key={rule}>{rule}</li>)}</ul> : null}
    </section>
  )
}
